import { DEPLOY_ENV } from 'config';

/**
 * Given a date and a timezone computes the timezone offset or in laymans terms
 * the difference in minutes between the timezone of the input date and the
 * second argument.
 * @param date
 * @param timeZone a valid timezone e.g. 'Europe/Rome'
 * @see https://stackoverflow.com/a/29268535
 * @return The timezone offset or null if it couldn't be computed.
 */
export default function computeTimezoneOffset(
  date: Date,
  timeZone: string,
): number | null {
  let iso: string;

  try {
    // Abuse the Intl API to get a local ISO 8601 string for a given time zone.
    iso = date
      .toLocaleString('en-CA', { timeZone, hour12: false })
      .replace(', ', 'T');

    // Include the milliseconds from the original timestamp
    iso += '.' + date.getMilliseconds().toString().padStart(3, '0');

    // Lie to the Date object constructor that it's a UTC time.
    const lie = new Date(iso + 'Z').getTime();

    // Return the difference in timestamps, as minutes
    // Positive values are West of GMT, opposite of ISO 8601
    // this matches the output of `Date.getTimeZoneOffset`
    return -(lie - date.getTime()) / 60 / 1000;
  } catch (likelyTimezoneNotSupportedError) {
    if (DEPLOY_ENV === 'development') {
      console.error('computeTimezoneOffset', likelyTimezoneNotSupportedError);
    }

    return null;
  }
}
